export default {
      id: "ic-comment-arrow-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-comment-arrow-usage",
      toString: function () {
        return this.url;
      }
    }